import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Stack, Typography, alpha, useTheme } from "@mui/material";

import { marketplaceTypography as mt } from "../constants/marketplaceTypography";

interface MarketplaceConfigErrorProps {
  title?: string;
  message: string;
}

/** Tela de erro — configuração do marketplace inválida ou indisponível. */
export function MarketplaceConfigError({
  title = "Dispensação indisponível",
  message,
}: MarketplaceConfigErrorProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 2.5 },
        borderRadius: 2,
        border: "1px solid",
        borderColor: alpha(theme.palette.error.main, 0.28),
        bgcolor: alpha(theme.palette.error.main, 0.06),
      }}
    >
      <Stack spacing={1.25} alignItems="flex-start">
        <Stack direction="row" spacing={1} alignItems="center">
          <ErrorOutlineIcon color="error" fontSize="small" />
          <Typography sx={{ ...mt.sectionTitle, color: "error.dark" }}>
            {title}
          </Typography>
        </Stack>
        <Typography sx={{ ...mt.body, color: "text.secondary" }}>{message}</Typography>
      </Stack>
    </Box>
  );
}
